// @flow
import { path } from 'ramda'
import { getRadioChannelsBrief } from '@alphaott/api-client'
import { getPublicDomain, getContentDomain, getCacheChannels, isCacheValid } from '@alphaott/app-main/selectors'

export const FETCH_RADIO_CHANNELS_TYPE = 'radioChannels/FETCH_CHANNELS'
export const FILTER_OPEN_RADIO_CHANNEL = 'radioChannels/FILTER_OPEN'

export type FilterOpenRadioChannelAction = {|
  type: 'radioChannels/FILTER_OPEN',
  isOpenFilter: boolean,
|}

const fetchRadioChannelsAction = (serviceSpec: string) => (dispatch: Function, getState: Function) => {
  const state = getState()
  const publicApi = getPublicDomain(state)
  const contentApi = getContentDomain(state)
  const ttl = getCacheChannels(state)

  return dispatch({
    type: FETCH_RADIO_CHANNELS_TYPE,
    payload: getRadioChannelsBrief(publicApi, serviceSpec),
    meta: {
      contentApi,
      ttl,
    },
  })
}

// eslint-disable-next-line complexity
export const fetchRadioChannels = (serviceSpec: string, force?: boolean = false) => (
  dispatch: Function,
  getState: Function,
) => {
  if (force) return dispatch(fetchRadioChannelsAction(serviceSpec))

  const state = getState()
  const expires = path(['channels', 'expires'], state)

  if (expires && isCacheValid(expires)) return null

  return dispatch(fetchRadioChannelsAction(serviceSpec))
}

export const filterOpenRadioChannel = (isOpenFilter: boolean): FilterOpenRadioChannelAction => ({
  type: FILTER_OPEN_RADIO_CHANNEL,
  isOpenFilter,
})
